import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'error-component',
  template: '<div>An error is to be thrown and logged</div>',
  standalone: false
})
export class ErrorTestComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    throw new Error('An error is thrown by this component!');
  }
}
